import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ToastrService } from 'ngx-toastr';
import { ProcurementService } from '../_services/procurement.service';
import { AuthenticationService } from '../_services/authentication.service';
import { LookupService } from '../_services/lookup.service';
import { UtilityService } from '../_helpers/utility.service';
import { Request } from '../_model/procurement/Request';
import { Expense } from '../_model/procurement/Expense';
import { RequestDialogComponent } from './request-dialog/request-dialog.component';
import { ApproveDialogComponent } from './approve-dialog/approve-dialog.component';
import { RejectDialogComponent } from './reject-dialog/reject-dialog.component';
import { ProcurementSearchRequest } from '../_model/request/ProcurementSearchRequest';
import { AppConstants } from '../_utils/constants';
import moment from 'moment';

@Component({
  selector: 'app-procurement',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatTabsModule,
    MatTableModule,
    MatExpansionModule,
    MatDialogModule,
    MatIconModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule
  ],
  templateUrl: './procurement.component.html',
  styleUrls: ['./procurement.component.scss']
})
export class ProcurementComponent implements OnInit {
  
  // Tab datasources
  dsWaitings: Request[] = [];      // Onay Bekleyenler
  dsMyRequests: Request[] = [];    // Taleplerim
  dsApproved: Request[] = [];      // Onaylananlar
  dsRejected: Request[] = [];      // Reddedilenler
  dsAllRequests: Request[] = [];   // Tüm Kayıtlar
  
  currentUser: any;
  
  displayedColumns: string[] = ['poNumber','createdDate', 'fullName', 'type', 'pgGroup', 'pgdGroup', 'status', 'actions'];
  displayedColumnsApproved: string[] = ['poNumber','erpNumber','createdDate', 'fullName', 'type', 'pgGroup', 'pgdGroup', 'status', 'actions'];
  
  selectedTab: number = 0;

  // Filter values for each tab
  startDateFilterValue1 = new FormControl();
  endDateFilterValue1 = new FormControl();
  startDateFilterValue2 = new FormControl();
  endDateFilterValue2 = new FormControl();
  startDateFilterValue3 = new FormControl();
  endDateFilterValue3 = new FormControl();
  startDateFilterValue4 = new FormControl();
  endDateFilterValue4 = new FormControl();
  startDateFilterValue5 = new FormControl();
  endDateFilterValue5 = new FormControl();

  typeList: any[] = [
    { value: null, description: 'Hepsi' },
    { value: 'REQUISITION', description: 'Talep' },
    { value: 'EXPENSE', description: 'Masraf' }
  ];
  selectedType1: any = this.typeList[0];
  selectedType2: any = this.typeList[0];
  selectedType3: any = this.typeList[0];
  selectedType4: any = this.typeList[0];
  selectedType5: any = this.typeList[0];

  projectList: any[] = [{ code: null, description: 'Hepsi' }];
  selectedProject1: any = this.projectList[0];
  selectedProject2: any = this.projectList[0];
  selectedProject3: any = this.projectList[0];
  selectedProject4: any = this.projectList[0];
  selectedProject5: any = this.projectList[0];

  statusList: any[] = [
    { value: null, description: 'Hepsi' },
    { value: 'BEKLIYOR', description: 'Bekliyor' },
    { value: 'ONAYLANDI', description: 'Onaylandı' },
    { value: 'REDDEDILDI', description: 'Reddedildi' }
  ];
  selectedStatus5: any = this.statusList[0];

  searchFullName1 = '';
  searchFullName2 = '';
  searchFullName3 = '';
  searchFullName4 = '';
  searchFullName5 = '';

  searchPoNumber1 = '';
  searchPoNumber2 = '';
  searchPoNumber3 = '';
  searchPoNumber4 = '';
  searchPoNumber5 = '';

  size = 20;
  pageNumber = 0;
  procurementSearchRequest: ProcurementSearchRequest = new ProcurementSearchRequest(
    this.pageNumber,
    this.size,
    null,
    null
  );

  constructor(
    private procurementService: ProcurementService,
    private authService: AuthenticationService,
    private lookupService: LookupService,
    private utilityService: UtilityService,
    private dialog: MatDialog,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    // Get current user from auth service
    this.currentUser = this.authService.currentUserValue;
    console.log('Current user:', this.currentUser);
    console.log('Is manager:', this.currentUser?.manager);
    console.log('Is HR:', this.currentUser?.hr);
    
    this.loadProjects();
    this.loadData();
  }

  loadProjects(): void {
    this.lookupService.listByLookupCode('PROJECT').subscribe({
      next: (response) => {
        if (response.success && response.responseData.items) {
          const allOption = { code: null, description: 'Hepsi' };
          this.projectList = [allOption, ...response.responseData.items];
          this.selectedProject1 = this.projectList[0];
          this.selectedProject2 = this.projectList[0];
          this.selectedProject3 = this.projectList[0];
          this.selectedProject4 = this.projectList[0];
          this.selectedProject5 = this.projectList[0];
        }
      },
      error: (error) => {
        console.error('Error loading projects:', error);
      }
    });
  }

  formatCreatedAt(createdAt?: number[]): string {
    if (!createdAt || createdAt.length < 6) return '-';
    const [year, month, day, hour, minute, second] = createdAt;
    const date = new Date(year, month - 1, day, hour, minute, second);
    return date.toLocaleDateString('tr-TR');
  }

  translateStatus(status: string): string {
    const statusMap: { [key: string]: string } = {
      'NEW': 'Yeni',
      'WAITING': 'Bekliyor',
      'APPROVED': 'Onaylandı',
      'REJECTED': 'Reddedildi',
      'BEKLIYOR': 'Bekliyor',
      'ONAYLANDI': 'Onaylandı',
      'REDDEDILDI': 'Reddedildi'
    };
    return statusMap[status?.toUpperCase()] || status;
  }

  loadData(): void {
    // Onay Bekleyenler - Waiting for Approvals
    this.procurementService.getWaitingForApprovals(this.procurementSearchRequest).subscribe({
      next: (response) => {
        if (response.success) {
          console.log('Backend waiting approvals response:', response.responseData?.items?.[0]);
          this.dsWaitings = (response.responseData?.items || response.responseData || []).map((item: Request) => ({
            ...item,
            createdDate: this.formatCreatedAt(item.createdAt),
            status: this.translateStatus(item.status)
          }));
          console.log('Mapped waiting item:', this.dsWaitings[0]);
        }
      },
      error: (error) => {
        console.error('Error loading waiting approvals:', error);
        this.toastr.error('Onay bekleyenler yüklenirken hata oluştu', 'Hata');
      }
    });

    // Taleplerim - My Requests
    this.procurementService.getMyRequests(this.procurementSearchRequest).subscribe({
      next: (response) => {
        if (response.success) {
          this.dsMyRequests = (response.responseData?.items || response.responseData || []).map((item: Request) => ({
            ...item,
            createdDate: this.formatCreatedAt(item.createdAt),
            status: this.translateStatus(item.status)
          }));
        }
      },
      error: (error) => {
        console.error('Error loading my requests:', error);
        this.toastr.error('Taleplerim yüklenirken hata oluştu', 'Hata');
      }
    });

    // Onaylananlar - Approved
    this.procurementService.getApproveds(this.procurementSearchRequest).subscribe({
      next: (response) => {
        if (response.success) {
          this.dsApproved = (response.responseData?.items || response.responseData || []).map((item: Request) => ({
            ...item,
            createdDate: this.formatCreatedAt(item.createdAt),
            status: this.translateStatus(item.status)
          }));
        }
      },
      error: (error) => {
        console.error('Error loading approved:', error);
        this.toastr.error('Onaylananlar yüklenirken hata oluştu', 'Hata');
      }
    });

    // Reddedilenler - Rejected
    this.procurementService.getRejecteds(this.procurementSearchRequest).subscribe({
      next: (response) => {
        if (response.success) {
          this.dsRejected = (response.responseData?.items || response.responseData || []).map((item: Request) => ({
            ...item,
            createdDate: this.formatCreatedAt(item.createdAt),
            status: this.translateStatus(item.status)
          }));
        }
      },
      error: (error) => {
        console.error('Error loading rejected:', error);
        this.toastr.error('Reddedilenler yüklenirken hata oluştu', 'Hata');
      }
    });

    // Tüm Kayıtlar - All Records
    this.procurementService.getAllRequests(this.procurementSearchRequest).subscribe({
      next: (response) => {
        if (response.success) {
          this.dsAllRequests = (response.responseData?.items || response.responseData || []).map((item: Request) => ({
            ...item,
            createdDate: this.formatCreatedAt(item.createdAt),
            status: this.translateStatus(item.status)
          }));
        }
      },
      error: (error) => {
        console.error('Error loading all requests:', error);
        this.toastr.error('Tüm kayıtlar yüklenirken hata oluştu', 'Hata');
      }
    });
  }

  openRequestDialog(): void {
    const dialogRef = this.dialog.open(RequestDialogComponent, {
      width: '95vw',
      maxWidth: '95vw',
      height: '95vh',
      maxHeight: '95vh',
      disableClose: true,
      data: {}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result?.success) {
        this.toastr.success('Kayıt başarıyla oluşturuldu', 'Başarılı');
        this.loadData(); // Refresh all data
      } else if (result === undefined) {
        // Dialog cancelled, no action needed
      }
    });
  }

  deleteRequest(id: number): void {
    if (confirm('Bu kaydı silmek istediğinizden emin misiniz?')) {
      this.procurementService.deleteRequest(id).subscribe({
        next: (response) => {
          if (response.success) {
            this.toastr.success('Kayıt silindi', 'Başarılı');
            this.loadData();
          }
        },
        error: (error) => {
          console.error('Delete error:', error);
          this.toastr.error('Silme işlemi başarısız', 'Hata');
        }
      });
    }
  }

  viewRequest(request: Request): void {
    console.log('viewRequest called with request:', request);
    console.log('request.id:', request.id);
    
    // Array item'dan gelen verileri al (üst bilgiler)
    const arrayItemData = {
      id: request.id,
      type: request.type,
      explanation: request.explanation,
      pgCode: request.pgCode,
      pgdCode: request.pgdCode,
      wgCode: request.wgCode,
      pgCodeDesc: request.pgCodeDesc,
      pgdCodeDesc: request.pgdCodeDesc,
      wgCodeDesc: request.wgCodeDesc,
      vendorId: request.vendorId,
      otherVendorTaxNumber: request.otherVendorTaxNumber,
      otherVendorName: request.otherVendorName,
      paymentType: request.paymentType,
      selectedCard: request.selectedCard,
      fullName: request.fullName,
      status: request.status,
      createdAt: request.createdAt
    };
    
    console.log('arrayItemData:', arrayItemData);

    // Detail API'sinden detayları çek
    this.procurementService.getRequestDetail(request.id).subscribe({
      next: (response) => {
        if (response.success) {
          const detailData = response.responseData?.item || response.responseData;
          console.log('API Detail Response:', detailData);
          
          // detailData'dan id'yi çıkar (çünkü null geliyor ve arrayItemData'daki id'yi ezmemeli)
          const { id: detailId, ...detailDataWithoutId } = detailData;
          
          // Array item ve detail verilerini birleştir - arrayItemData'daki id korunacak
          const completeRequest = {
            ...arrayItemData,
            ...detailDataWithoutId,
            // details array'ini kesinlikle kullan
            details: detailData.details || []
          };
          
          console.log('Complete Request Data:', completeRequest);
          console.log('Complete Request ID:', completeRequest.id);
          
          const dialogRef = this.dialog.open(RequestDialogComponent, {
            width: '95vw',
            maxWidth: '95vw',
            height: '95vh',
            maxHeight: '95vh',
            disableClose: false,
            data: {
              request: completeRequest,
              isReadOnly: true,
              showApproveReject: request.status === 'NEW' // Sadece NEW durumunda onay/red butonlarını göster
            }
          });

          dialogRef.afterClosed().subscribe((result) => {
            if (result?.approved || result?.rejected) {
              // Onay veya red yapıldıysa listeyi yenile
              this.loadData();
            }
          });
        }
      },
      error: (error) => {
        console.error('Get detail error:', error);
        this.toastr.error('Detay yüklenirken hata oluştu', 'Hata');
      }
    });
  }

  approveRequest(request: Request): void {
    const dialogRef = this.dialog.open(ApproveDialogComponent, {
      width: '400px',
      minHeight: '80px',
      data: request
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        // Başarılı onay - listeyi güncelle
        this.loadData();
      }
    });
  }

  rejectRequest(request: Request): void {
    const dialogRef = this.dialog.open(RejectDialogComponent, {
      width: '400px',
      data: request
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        // Başarılı red - listeyi güncelle
        this.loadData();
      }
    });
  }

  filterGrid(tabNo: number): void {
    this.procurementSearchRequest.pageNumber = 0;

    if (tabNo === 0) { // Onay bekleyenler
      const selectedDate = this.endDateFilterValue1.value ? new Date(this.endDateFilterValue1.value) : null;
      if (selectedDate) {
        selectedDate.setHours(23, 59, 59, 0);
      }

      this.procurementSearchRequest.poStartDate = this.startDateFilterValue1.value 
        ? this.utilityService.converDateToStringWithFormat(this.startDateFilterValue1.value, AppConstants.MOMENT_DATETIME_FORMAT_2) 
        : null;
      this.procurementSearchRequest.poEndDate = selectedDate
        ? this.utilityService.converDateToStringWithFormat(selectedDate, AppConstants.MOMENT_DATETIME_FORMAT_2)
        : null;
      this.procurementSearchRequest.type = this.selectedType1.value;
      this.procurementSearchRequest.projectCode = this.selectedProject1.code;
      this.procurementSearchRequest.fullName = this.searchFullName1;
      this.procurementSearchRequest.poNumber = this.searchPoNumber1 || null;
      this.procurementSearchRequest.status = null;

      this.procurementService.getWaitingForApprovals(this.procurementSearchRequest).subscribe({
        next: (response) => {
          if (response.success) {
            this.dsWaitings = (response.responseData?.items || response.responseData || []).map((item: Request) => ({
              ...item,
              createdDate: this.formatCreatedAt(item.createdAt)
            }));
          }
        }
      });
    } else if (tabNo === 1) { // Taleplerim
      const selectedDate = this.endDateFilterValue2.value ? new Date(this.endDateFilterValue2.value) : null;
      if (selectedDate) {
        selectedDate.setHours(23, 59, 59, 0);
      }

      this.procurementSearchRequest.poStartDate = this.startDateFilterValue2.value
        ? this.utilityService.converDateToStringWithFormat(this.startDateFilterValue2.value, AppConstants.MOMENT_DATETIME_FORMAT_2)
        : null;
      this.procurementSearchRequest.poEndDate = selectedDate
        ? this.utilityService.converDateToStringWithFormat(selectedDate, AppConstants.MOMENT_DATETIME_FORMAT_2)
        : null;
      this.procurementSearchRequest.type = this.selectedType2.value;
      this.procurementSearchRequest.projectCode = this.selectedProject2.code;
      this.procurementSearchRequest.fullName = this.searchFullName2;
      this.procurementSearchRequest.poNumber = this.searchPoNumber2 || null;
      this.procurementSearchRequest.status = null;

      this.procurementService.getMyRequests(this.procurementSearchRequest).subscribe({
        next: (response) => {
          if (response.success) {
            this.dsMyRequests = (response.responseData?.items || response.responseData || []).map((item: Request) => ({
              ...item,
              createdDate: this.formatCreatedAt(item.createdAt)
            }));
          }
        }
      });
    } else if (tabNo === 2) { // Onayladıklarım
      const selectedDate = this.endDateFilterValue3.value ? new Date(this.endDateFilterValue3.value) : null;
      if (selectedDate) {
        selectedDate.setHours(23, 59, 59, 0);
      }

      this.procurementSearchRequest.poStartDate = this.startDateFilterValue3.value
        ? this.utilityService.converDateToStringWithFormat(this.startDateFilterValue3.value, AppConstants.MOMENT_DATETIME_FORMAT_2)
        : null;
      this.procurementSearchRequest.poEndDate = selectedDate
        ? this.utilityService.converDateToStringWithFormat(selectedDate, AppConstants.MOMENT_DATETIME_FORMAT_2)
        : null;
      this.procurementSearchRequest.type = this.selectedType3.value;
      this.procurementSearchRequest.projectCode = this.selectedProject3.code;
      this.procurementSearchRequest.fullName = this.searchFullName3;
      this.procurementSearchRequest.poNumber = this.searchPoNumber3 || null;
      this.procurementSearchRequest.status = null;

      this.procurementService.getApproveds(this.procurementSearchRequest).subscribe({
        next: (response) => {
          if (response.success) {
            this.dsApproved = (response.responseData?.items || response.responseData || []).map((item: Request) => ({
              ...item,
              createdDate: this.formatCreatedAt(item.createdAt)
            }));
          }
        }
      });
    } else if (tabNo === 3) { // Reddettiklerim
      const selectedDate = this.endDateFilterValue4.value ? new Date(this.endDateFilterValue4.value) : null;
      if (selectedDate) {
        selectedDate.setHours(23, 59, 59, 0);
      }

      this.procurementSearchRequest.poStartDate = this.startDateFilterValue4.value
        ? this.utilityService.converDateToStringWithFormat(this.startDateFilterValue4.value, AppConstants.MOMENT_DATETIME_FORMAT_2)
        : null;
      this.procurementSearchRequest.poEndDate = selectedDate
        ? this.utilityService.converDateToStringWithFormat(selectedDate, AppConstants.MOMENT_DATETIME_FORMAT_2)
        : null;
      this.procurementSearchRequest.type = this.selectedType4.value;
      this.procurementSearchRequest.projectCode = this.selectedProject4.code;
      this.procurementSearchRequest.fullName = this.searchFullName4;
      this.procurementSearchRequest.poNumber = this.searchPoNumber4 || null;
      this.procurementSearchRequest.status = null;

      this.procurementService.getRejecteds(this.procurementSearchRequest).subscribe({
        next: (response) => {
          if (response.success) {
            this.dsRejected = (response.responseData?.items || response.responseData || []).map((item: Request) => ({
              ...item,
              createdDate: this.formatCreatedAt(item.createdAt)
            }));
          }
        }
      });
    } else if (tabNo === 4) { // Tüm kayıtlar
      const selectedDate = this.endDateFilterValue5.value ? new Date(this.endDateFilterValue5.value) : null;
      if (selectedDate) {
        selectedDate.setHours(23, 59, 59, 0);
      }

      this.procurementSearchRequest.poStartDate = this.startDateFilterValue5.value
        ? this.utilityService.converDateToStringWithFormat(this.startDateFilterValue5.value, AppConstants.MOMENT_DATETIME_FORMAT_2)
        : null;
      this.procurementSearchRequest.poEndDate = selectedDate
        ? this.utilityService.converDateToStringWithFormat(selectedDate, AppConstants.MOMENT_DATETIME_FORMAT_2)
        : null;
      this.procurementSearchRequest.type = this.selectedType5.value;
      this.procurementSearchRequest.projectCode = this.selectedProject5.code;
      this.procurementSearchRequest.fullName = this.searchFullName5;
      this.procurementSearchRequest.poNumber = this.searchPoNumber5 || null;
      this.procurementSearchRequest.status = this.selectedStatus5.value;

      this.procurementService.getAllRequests(this.procurementSearchRequest).subscribe({
        next: (response) => {
          if (response.success) {
            this.dsAllRequests = (response.responseData?.items || response.responseData || []).map((item: Request) => ({
              ...item,
              createdDate: this.formatCreatedAt(item.createdAt)
            }));
          }
        }
      });
    }
  }

  clearFilterGrid(tabNo: number): void {
    if (tabNo === 0) {
      this.selectedType1 = this.typeList[0];
      this.selectedProject1 = this.projectList[0];
      this.startDateFilterValue1.setValue(null);
      this.endDateFilterValue1.setValue(null);
      this.searchFullName1 = '';
      this.searchPoNumber1 = '';
    } else if (tabNo === 1) {
      this.selectedType2 = this.typeList[0];
      this.selectedProject2 = this.projectList[0];
      this.startDateFilterValue2.setValue(null);
      this.endDateFilterValue2.setValue(null);
      this.searchFullName2 = '';
      this.searchPoNumber2 = '';
    } else if (tabNo === 2) {
      this.selectedType3 = this.typeList[0];
      this.selectedProject3 = this.projectList[0];
      this.startDateFilterValue3.setValue(null);
      this.endDateFilterValue3.setValue(null);
      this.searchFullName3 = '';
      this.searchPoNumber3 = '';
    } else if (tabNo === 3) {
      this.selectedType4 = this.typeList[0];
      this.selectedProject4 = this.projectList[0];
      this.startDateFilterValue4.setValue(null);
      this.endDateFilterValue4.setValue(null);
      this.searchFullName4 = '';
      this.searchPoNumber4 = '';
    } else if (tabNo === 4) {
      this.selectedType5 = this.typeList[0];
      this.selectedProject5 = this.projectList[0];
      this.selectedStatus5 = this.statusList[0];
      this.startDateFilterValue5.setValue(null);
      this.endDateFilterValue5.setValue(null);
      this.searchFullName5 = '';
      this.searchPoNumber5 = '';
    }
    this.filterGrid(tabNo);
  }
}